import React from 'react';

const CheckBoxActive = (props) => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width="32" height="32" rx="6" fill="#19135E" />
    <rect width="32" height="32" rx="6" fill="#0F1A7D" />
    <rect width="32" height="32" rx="6" fill="#2346F2" />
    <path d="M9.33398 15.1111L14.6673 19.9999L24.0007 10.2222" stroke="white" strokeWidth="2" strokeMiterlimit="10" />
  </svg>
);

export default CheckBoxActive;
